var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
const __default__ = {
    name: "DescribeObjectStore",
};
import { computed, ref, watch } from "vue";
import { QuotaSourceUsageProvider } from "@/components/User/DiskUsage/Quota/QuotaUsageProvider.js";
import ConfigurationMarkdown from "./ConfigurationMarkdown.vue";
import ObjectStoreBadges from "./ObjectStoreBadges.vue";
import ObjectStoreRestrictionSpan from "./ObjectStoreRestrictionSpan.vue";
import QuotaUsageBar from "@/components/User/DiskUsage/Quota/QuotaUsageBar.vue";
export default /*#__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { props: {
        storageInfo: null,
        what: null
    }, setup(__props, { expose }) {
        const props = __props;
        const quotaSourceLabel = computed(() => { var _a; return (_a = props.storageInfo.quota) === null || _a === void 0 ? void 0 : _a.source; });
        const isPrivate = computed(() => props.storageInfo.private);
        const badges = computed(() => props.storageInfo.badges);
        const quotaUsageProvider = ref(null);
        watch(props, () => __awaiter(this, void 0, void 0, function* () {
            if (quotaUsageProvider.value) {
                // @ts-ignore
                quotaUsageProvider.value.update({ quotaSourceLabel: quotaSourceLabel.value });
            }
        }));
        expose({
            isPrivate,
        });
        return { __sfc: true, props, quotaSourceLabel, isPrivate, badges, quotaUsageProvider, QuotaSourceUsageProvider, ConfigurationMarkdown, ObjectStoreBadges, ObjectStoreRestrictionSpan, QuotaUsageBar };
    } }));
